import translate from "./translate";

export const cardContentTranslate = {
  customerRating: translate("customerRating"),
};

export const menuHeaderTranslate = {
  homepage: translate("homepage"),
  vacancies: translate("vacancies"),
};

export const homePagePersonalTranslate = {
  workAs: translate("workAs"),
  areasInterest: translate("areasInterest"),
  selectArea: translate("selectArea"),
  myResume: translate("myResume"),
  showVacancies: translate("showVacancies"),
  salaryConsult: translate("salaryConsult"),
};

export const professionalExperienceTranslate = {
  professionalExperienceDesc: translate("professionalExperienceDesc"),
};

export const componentsTranslate = {
  searchByName: translate("searchByName"),
};

export const modalAssignTranslate = {
  btnClose: translate("closeButton"),
  btnSave: translate("saveButton"),
  confirmDelete: translate("confirmDelete"),
  deleteButton: translate("deleteButton"),
  cancelButton: translate("cancelButton"),
  yesText: translate("yesText"),
  noText: translate("noText"),
  clickHere: translate("clickHere"),
};

export const addEmployeeTranslate = {
  assignCollaborator: translate("assignCollaborator"),
  collaboratorTitle: translate("collaboratorTitle"),
  nullEmployersRegister: translate("nullEmployersRegister"),
  closeBtn: translate("closeButton"),
  sabeBtn: translate("saveButton"),
};

export const loginTranslate = {
  textLogin: translate("textLogin"),
  createAccount: translate("createAccount"),
  login: translate("login"),
  errorUserPass: translate("errorUserPass"),
  passPH: translate("passPH"),
  mobileLoginScreenTitle: translate("mobileLoginScreenTitle"),
  mobileLoginScreenText: translate("mobileLoginScreenText"),
};

export const mainMenuTextsTranslate = {
  mainMenuFeed: translate("mainMenuFeed"),
  mainMenuProfile: translate("mainMenuProfile"),
  mainMenuMoment: translate("mainMenuMoment"),
  mainMenuVacancies: translate("mainMenuVacancies"),
  mainMenuCompany: translate("mainMenuCompany"),
  mainMenuSearch: translate("mainMenuSearch"),
  mainMenuSeeMore: translate("mainMenuSeeMore"),
  dropdownCompany: translate("dropdownCompany"),
  dropdownLogout: translate("dropdownLogout"),
  dropdownProfile: translate("dropdownProfile"),
};

export const employeeExperienceTranslate = {
  EEMonth: translate("EEMonth"),
  EEYear: translate("EEYear"),

  //HistoricProfessional
  historicProfessionalEENameCompany: translate("historicProfessionalEENameCompany"),
  historicProfessionalEEAreaCompany: translate("historicProfessionalEEAreaCompany"),
  historicProfessionalEEOption0: translate("historicProfessionalEEOption0"),
  historicProfessionalEEOption1: translate("historicProfessionalEEOption1"),
  historicProfessionalEEOption2: translate("historicProfessionalEEOption2"),
  historicProfessionalEEOption3: translate("historicProfessionalEEOption3"),
  historicProfessionalEEOption4: translate("historicProfessionalEEOption4"),
  historicProfessionalEEOption5: translate("historicProfessionalEEOption5"),
  historicProfessionalEEOption6: translate("historicProfessionalEEOption6"),
  historicProfessionalEEOption7: translate("historicProfessionalEEOption7"),
  historicProfessionalEEOption8: translate("historicProfessionalEEOption8"),
  historicProfessionalEEOption9: translate("historicProfessionalEEOption9"),
  historicProfessionalEEOption10: translate("historicProfessionalEEOption10"),
  historicProfessionalEEOption11: translate("historicProfessionalEEOption11"),
  historicProfessionalEEOption12: translate("historicProfessionalEEOption12"),
  historicProfessionalEEOption13: translate("historicProfessionalEEOption13"),
  historicProfessionalEEOption14: translate("historicProfessionalEEOption14"),
  historicProfessionalEEOption15: translate("historicProfessionalEEOption15"),
  historicProfessionalEEOption16: translate("historicProfessionalEEOption16"),
  historicProfessionalEEOption17: translate("historicProfessionalEEOption17"),
  historicProfessionalEEOption18: translate("historicProfessionalEEOption18"),
  historicProfessionalEEOption19: translate("historicProfessionalEEOption19"),
  historicProfessionalEEOption20: translate("historicProfessionalEEOption20"),
  historicProfessionalEEOption21: translate("historicProfessionalEEOption21"),
  historicProfessionalEEOption22: translate("historicProfessionalEEOption22"),
  historicProfessionalEEOption23: translate("historicProfessionalEEOption23"),
  historicProfessionalEEOption24: translate("historicProfessionalEEOption24"),
  historicProfessionalEEOption25: translate("historicProfessionalEEOption25"),
  historicProfessionalEEOption26: translate("historicProfessionalEEOption26"),
  historicProfessionalEEOption27: translate("historicProfessionalEEOption27"),
  historicProfessionalEEOption28: translate("historicProfessionalEEOption28"),
  historicProfessionalEEOption29: translate("historicProfessionalEEOption29"),
  historicProfessionalEEOption30: translate("historicProfessionalEEOption30"),
  historicProfessionalEEOption31: translate("historicProfessionalEEOption31"),
  historicProfessionalEEOption32: translate("historicProfessionalEEOption32"),
  historicProfessionalEEOption33: translate("historicProfessionalEEOption33"),
  historicProfessionalEEJob: translate("historicProfessionalEEJob"),
  historicProfessionalEEEntryDate: translate("historicProfessionalEEEntryDate"),

  historicProfessionalEEActualJob: translate("historicProfessionalEEActualJob"),
  historicProfessionalEELeaveDate: translate("historicProfessionalEELeaveDate"),
  historicProfessionalEEHierarchicalLevel: translate("historicProfessionalEEHierarchicalLevel"),
  historicProfessionalEEArea: translate("historicProfessionalEEArea"),

  //Formation
  formationEENameUniversity: translate("formationEENameUniversity"),
  formationEEType: translate("formationEEType"),
  formationEEOption1: translate("formationEEOption1"),
  formationEEOption2: translate("formationEEOption2"),
  formationEEOption3: translate("formationEEOption3"),
  formationEEOption4: translate("formationEEOption4"),
  formationEEOption5: translate("formationEEOption5"),
  formationEECourse: translate("formationEECourse"),
  formationEEEntryDateCourse: translate("formationEEEntryDateCourse"),
  formationEECurrentlyStuding: translate("formationEECurrentlyStuding"),
  formationEEYes: translate("formationEEYes"),
  formationEELeaveDateCourse: translate("formationEELeaveDateCourse"),
  formationEECurrentlyWorking: translate("formationEECurrentlyWorking"),
  formationDesc: translate("formationDesc"),

  //ClimeQuestions
  climeQuestionsEEH1: "Muito Insatisfeito",
  climeQuestionsEEH2: translate("climeQuestionsEEH2"),
  climeQuestionsEEH3: translate("climeQuestionsEEH3"),
  climeQuestionsEEH4: translate("climeQuestionsEEH4"),
  climeQuestionsEETitle1: translate("climeQuestionsEETitle1"),
  climeQuestionEE1: translate("climeQuestionEE1"),
  climeQuestionEE2: translate("climeQuestionEE2"),
  climeQuestionEE3: translate("climeQuestionEE3"),
  climeQuestionEE4: translate("climeQuestionEE4"),
  climeQuestionsEETitle2: translate("climeQuestionsEETitle2"),
  climeQuestionEE5: translate("climeQuestionEE5"),
  climeQuestionEE6: translate("climeQuestionEE6"),
  climeQuestionEE7: translate("climeQuestionEE7"),
  climeQuestionEE8: translate("climeQuestionEE8"),
  climeQuestionEE9: translate("climeQuestionEE9"),
  climeQuestionEE10: translate("climeQuestionEE10"),
  climeQuestionsEETitle3: translate("climeQuestionsEETitle3"),
  climeQuestionEE11: translate("climeQuestionEE11"),
  climeQuestionEE12: translate("climeQuestionEE12"),
  climeQuestionEE13: translate("climeQuestionEE13"),
  climeQuestionEE14: translate("climeQuestionEE14"),
  climeQuestionEE15: translate("climeQuestionEE15"),
  climeQuestionsEETitle4: translate("climeQuestionsEETitle4"),
  climeQuestionEE16: translate("climeQuestionEE16"),
  climeQuestionEE17: translate("climeQuestionEE17"),
  climeQuestionEE18: translate("climeQuestionEE18"),
  climeQuestionEE19: translate("climeQuestionEE19"),
  climeQuestionEE20: translate("climeQuestionEE20"),
  climeQuestionEE21: translate("climeQuestionEE21"),
  climeQuestionsEETitle6: translate("climeQuestionsEETitle6"),
  climeQuestionEE22: translate("climeQuestionEE22"),
  climeQuestionEE23: translate("climeQuestionEE23"),
  climeQuestionEE24: translate("climeQuestionEE24"),
  climeQuestionEE25: translate("climeQuestionEE25"),

  culturaQuestionEE1: translate("culturaQuestionEE1"),
  culturaQuestionEE2: translate("culturaQuestionEE2"),
  culturaQuestionEE3: translate("culturaQuestionEE3"),
  culturaQuestionEE4: translate("culturaQuestionEE4"),
  culturaQuestionEE5: translate("culturaQuestionEE5"),
  culturaQuestionEE6: translate("culturaQuestionEE6"),
  culturaQuestionEE7: translate("culturaQuestionEE7"),
  culturaQuestionEE8: translate("culturaQuestionEE8"),
  culturaQuestionEE9: translate("culturaQuestionEE9"),
  culturaQuestionEE10: translate("culturaQuestionEE10"),
  culturaQuestionEE11: translate("culturaQuestionEE11"),
  culturaQuestionEE12: translate("culturaQuestionEE12"),
  culturaQuestionEE13: translate("culturaQuestionEE13"),
  culturaQuestionEE14: translate("culturaQuestionEE14"),
  culturaQuestionEE15: translate("culturaQuestionEE15"),
  culturaQuestionEE16: translate("culturaQuestionEE16"),
  culturaQuestionEE17: translate("culturaQuestionEE17"),
  culturaQuestionEE18: translate("culturaQuestionEE18"),

  cultureQuestionsEEForMe: translate("cultureQuestionsEEForMe"),

  cultureDesc: translate("cultureDesc"),

  contractTypeEE: translate("contractTypeEE"),

  //CareerPlan
  directorCP: translate("directorCP"),
  managerCP: translate("managerCP"),
  submanagerCP: translate("submanagerCP"),
  bossCP: translate("bossCP"),
  specialistCP: translate("specialistCP"),
  analystCP: translate("analystCP"),
  operatorCP: translate("operatorCP"),

  //InternalJobs
  emptyInternalJobs: translate("emptyInternalJobs"),

  //InternalMessage
  emptyMessage: translate("emptyMessage"),
};

export const wheelCompanyTranslate = {
  seeMore: translate("seeMore"),
  peopleAnalytics: translate("peopleAnalytics"),
  learning: translate("onBoarding"),
  trainings: translate("trainingAndDevelopment"),
  climeAndCulture: translate("climeAndCulture"),
  culture: translate("culture"),
  performanceAnalysis: translate("performanceAnalysis"),
  salariesAndBenefits: translate("salariesAndBenefits"),
  professionalDevelopment: translate("professionalDevelopment"),
  careerPlan: translate("careerPlan"),
  ombudsman: translate("ombudsman"),
  outplacement: translate("outplacement"),
};

export const genesTranslate = {
  genesDesc: translate("genesDesc"),
  genesText1: translate("genesText1"),
  genesText2: translate("genesText2"),
  genesText3: translate("genesText3"),
  genesBtn: translate("genesBtn"),
};

export const smtmTranslate = {
  smtmTitle: translate("smtmTitle"),
  smtmDesc: translate("smtmDesc"),
  smtmText1: translate("smtmText1"),
  smtmText2: translate("smtmText2"),
  smtmText3: translate("smtmText3"),
  smtmText4: translate("smtmText4"),
  smtmText5: translate("smtmText5"),
  smtmText6: translate("smtmText6"),
  smtmBtn: translate("smtmBtn"),
};

export const jobsTranslate = {
  relatedJobs: translate("relatedJobs"),
  relatedJobsDesc: translate("relatedJobsDesc"),
  searchInputJobsPH: translate("searchInputJobsPH"),
  searchWithFilterText: translate("searchWithFilterText"),
  showAllJobs: translate("showAllJobs"),
  jobsOportunityText: translate("jobsOportunityText"),
  applyToJobBnt: translate("applyToJobBnt"),
  removeApplyBtn: translate("removeApplyBtn"),
};

export const presentationTranslate = {
  presentationTitle: translate("presentationTitle"),
  presentationDesc: translate("presentationDesc"),
  aboutYou: translate("aboutYou"),
  writePresentationPH: translate("writePresentationPH"),
  socialMedia: translate("socialMedia"),
  instagramLink: translate("instagramLink"),
  linkedinLink: translate("linkedinLink"),
  facebookLink: translate("facebookLink"),
  uploadVideoLink: translate("uploadVideoLink"),
  uploadLetterPresentation: translate("uploadLetterPresentation"),
  uploadFileDesc: translate("uploadFileDesc"),
  yourFile: translate("yourFile"),
  yourFileTitle: translate("yourFileTitle"),
  yourFileDownload: translate("yourFileDownload"),
  videoPresentation: translate("videoPresentation"),
};

export const defaultLevelsTranslate = {
  nullLevel: translate("nullLevel"),
  basicLevel: translate("basicLevel"),
  intermediaryLevel: translate("intermediaryLevel"),
  advancedLevel: translate("advancedLevel"),
  fluentLevel: translate("fluentLevel"),
};

export const myKnowledgeTranslate = {
  myKnowledgeTitle: translate("myKnowledgeTitle"),
  myKnowledgeText: translate("myKnowledgeText"),
  assignKnowledge: translate("assignKnowledge"),
  typeKnowledge: translate("typeKnowledge"),
  languageTrainingTitle: translate("languageTrainingTitle"),
  otherTrainingTitle: translate("otherTrainingTitle"),
  levelKnowledgeTitle: translate("levelKnowledgeTitle"),
};

export const cardSectionTranslate = {
  // titles
  collaborator360: translate("collaborator360"),
  dashboardCompany: translate("dashboardCompany"),
  executiveSearch: translate("executiveSearch"),
  middleTopManagement: translate("middleTopManagement"),
  backoffandStaff: translate("backoffandStaff"),
  plataformOnboardinGamified: translate("plataformOnboardinGamified"),
  englishClass: translate("englishClass"),
  commercialTraining: translate("commercialTraining"),
  gamefiedTraining: translate("gamefiedTraining"),
  cultureReport: translate("cultureReport"),
  culturalFitEmp: translate("culturalFitEmp"),
  culturalFitCol: translate("culturalFitCol"),
  culturalTransformation: translate("culturalTransformation"),
  performanceAnalysis: translate("performanceAnalysis"),
  realTimeConsult: translate("realTimeConsult"),
  customStudy: translate("customStudy"),
  variableSalary: translate("variableSalary"),
  salaryGuide: translate("salaryGuide"),
  motivacionalTest: translate("motivacionalTest"),
  knowMyco: translate("knowMyco"),
  skillTest: translate("skillTest"),
  englishLevel: translate("englishLevel"),
  careerProjection: translate("careerProjection"),
  salaryProjection: translate("salaryProjection"),
  jobDescriptor: translate("jobDescriptor"),
  topManagement: translate("topManagement"),
  middleManagement: translate("middleManagement"),
  backofficeOutput: translate("backofficeOutput"),
  searchOutput: translate("searchOutput"),

  // texts
  textCollaborator360: translate("textCollaborator360"),
  textDashboardCompany: translate("textDashboardCompany"),
  textExecutiveSearch: translate("textExecutiveSearch"),
  textMiddleTopManagement: translate("textMiddleTopManagement"),
  textBackoffandStaff: translate("textBackoffandStaff"),
  textPlataformOnboardinGamified: translate("textPlataformOnboardinGamified"),
  textEnglishClass: translate("textEnglishClass"),
  textCommercialTraining: translate("textCommercialTraining"),
  textGamefiedTraining: translate("textGamefiedTraining"),
  textCultureReport: translate("textCultureReport"),
  textCulturalFitEmp: translate("textCulturalFitEmp"),
  textCulturalFitCol: translate("textCulturalFitCol"),
  textCulturalTransformation: translate("textCulturalTransformation"),
  textPerformanceAnalysis: translate("textPerformanceAnalysis"),
  textRealTimeConsult: translate("textRealTimeConsult"),
  textCustomStudy: translate("textCustomStudy"),
  textVariableSalary: translate("textVariableSalary"),
  textSalaryGuide: translate("textSalaryGuide"),
  textMotivacionalTest: translate("textMotivacionalTest"),
  textKnowMyco: translate("textKnowMyco"),
  textSkillTest: translate("textSkillTest"),
  textEnglishLevel: translate("textEnglishLevel"),
  textCareerProjection: translate("textCareerProjection"),
  textSalaryProjection: translate("textSalaryProjection"),
  textJobDescriptor: translate("textJobDescriptor"),
  textTopManagement: translate("textTopManagement"),
  textMiddleManagement: translate("textMiddleManagement"),
  textBackofficeOutput: translate("textBackofficeOutput"),
  textSearchOutput: translate("textSearchOutput"),
};

export const lateralMenuTextTranslate = {
  myBusiness: translate("myBusiness"),

  peopleAnalytics: translate("peopleAnalytics"),
  myCollaborators: translate("myCollaborators"),
  collaboratorsRegister: translate("collaboratorsRegister"),
  massiveRegister: translate("massiveRegister"),
  campaignMenu: translate("campaignMenu"),

  onBoarding: translate("onBoarding"),
  knowBadgeHeroes: translate("knowBadgeHeroes"),
  onBoardingRegister: translate("onBoardingRegister"),

  trainingAndDevelopment: translate("trainingAndDevelopment"),
  manageTrainings: translate("manageTrainings"),
  workoutsMydna: translate("workoutsMydna"),
  ebooksAndContent: translate("ebooksAndContent"),

  climeAndCulture: translate("climeAndCulture"),
  climeSurvey: translate("climeSurvey"),
  nps: translate("nps"),
  businessCulture: translate("businessCulture"),
  matchCulture: translate("Match Cultural"),

  performanceAnalysis: translate("performanceAnalysis"),
  performanceEvaluation: translate("performanceEvaluation"),

  salariesAndBenefits: translate("salariesAndBenefits"),
  unitReport: translate("unitReport"),
  knowPaybalance: translate("knowPaybalance"),
  goPaybalance: translate("goPaybalance"),

  professionalDevelopment: translate("professionalDevelopment"),
  knowMyco: translate("knowMyco"),
  skillTest: translate("skillTest"),
  motivacionalTest: translate("motivacionalTest"),
  englishLevelTest: translate("englishLevelTest"),

  careerPlan: translate("careerPlan"),
  careerProjection: translate("careerProjection"),
  jobDescriptor: translate("jobDescriptor"),

  ombudsman: translate("ombudsman"),
  occurrences: translate("occurrences"),

  outplacement: translate("outplacement"),
  knowGenes: translate("knowGenes"),
  realocation: translate("realocation"),
  leaveSearch: translate("leaveSearch"),

  posicionesTitle: translate("posicionesTitle"),
  emotionalSalary: translate("emotionalSalary"),
  benefits: translate("benefits"),
};

export const headerTextTranslate = {
  myBusiness: translate("myBusiness"),
  myCollaborators: translate("myCollaborators"),
  mySolutions: translate("mySolutions"),
  myPartnes: translate("myPartnes"),
};

export const bodyTextTranslate = {
  ourProducts: translate("ourProducts"),
  customerEvaluation: translate("customerEvaluation"),
  apresentationDown: translate("apresentationDown"),

  textServices: translate("textServices"),
  textCertified: translate("textCertified"),

  myBusiness: translate("myBusiness"),
  peopleAnalytics: translate("peopleAnalytics"),
  recruitmentAndSelection: translate("recruitmentAndSelection"),
  learning: translate("learning"),
  trainings: translate("trainings"),
  performanceAnalysis: translate("performanceAnalysis"),
  salariesAndBenefits: translate("salariesAndBenefits"),
  careerPlan: translate("careerPlan"),
  cultureAnalysis: translate("cultureAnalysis"),
  professionalDevelopment: translate("professionalDevelopment"),
  outplacement: translate("outplacement"),

  activeService: translate("activeService"),
};

export const myCollaboratorsTranslate = {
  myCollaboratorsTitle: translate("myCollaboratorsTitle"),
  searchCollaborator: translate("searchCollaborator"),
  loadCollaborator: translate("loadCollaborator"),
  notDoneCultureSearch: translate("notDoneCultureSearch"),
  noCollaboratorsRegistered: translate("noCollaboratorsRegistered"),
};

export const wheelCollaboratorTranslate = {
  professionalHistoric: translate("professionalHistoric"),
  purpose: translate("purpose"),
  formation: translate("formation"),
  culture: translate("culture"),
  salary: translate("salary"),
  habilities: translate("habilities"),
  motivacions: translate("motivacions"),
  performance: translate("performance"),
  training: translate("training"),
  careerPlan: translate("careerPlan"),
  climeAndCulture: translate("climeAndCulture"),
  aData: translate("aData"),
  functionsTitle: translate("functionsTitle"),
  achievementsTitle: translate("achievementsTitle"),
  currentJobTitle: translate("currentJobTitle"),
  functionsDescriptions: translate("functionsDescriptions"),
  achievementsDescriptions: translate("achievementsDescriptions"),
  editProfile: translate("editProfile"),
  presentacion: translate("presentacion"),
  referencias: translate("referencias"),
  vacancies: translate("vacancies"),
  salarySurvey: translate("salarySurvey"),
  outplacement: translate("outplacement"),
  jobs: translate("jobs"),
  myResume: translate("myResume"),
};

export const professionalHistoricTranslate = {
  professionalHistoric: translate("professionalHistoric"),
  collaboratorTrajectory: translate("collaboratorTrajectory"),
  experienceTime: translate("experienceTime"),
  yearsAnd: translate("yearsAnd"),
  months: translate("months"),
  workedIndustries: translate("workedIndustries"),
  workedPositions: translate("workedPositions"),
};

export const purposeTranslate = {
  purposeTitle: translate("purpose"),
  purposeToWork: translate("purposeToWork"),
};

export const formationTranslate = {
  formationTitle: translate("formation"),
  education: translate("education"),
  englishLevel: translate("englishLevel"),
};

export const englishLineLevelTranslate = {
  nulo: translate("englishNulo"),
  basic: translate("englishBasic"),
  intermedio: translate("englishIntermedio"),
  avanzado: translate("englishAvanzado"),
  fluido: translate("englishFlued"),
};

export const cultureTranslate = {
  cultureTitle: translate("culture"),
  commercial: translate("commercial"),
  commercialText: translate("commercialText"),
  disruptive: translate("disruptive"),
  disruptiveText: translate("disruptiveText"),
  collaborative: translate("collaborative"),
  collaborativeText: translate("collaborativeText"),
  traditional: translate("traditional"),
  traditionalText: translate("traditionalText"),
  culturePreview: translate("culturePreview"),
};

export const salaryTitle = {
  salaryTitle: translate("salary"),
  actualSalary: translate("actualSalary"),
  fixedSalary: translate("fixedSalary"),
  variableAnualSalary: translate("variableAnualSalary"),
  titlePosiciones: translate("titlePosiciones"),
};

export const careerPlanTranslate = {
  careerPlanTitle: translate("careerPlan"),
  hierarchicalLevel: translate("hierarchicalLevel"),
  nextLevel: translate("nextLevel"),
  actualLevel: translate("actualLevel"),
  collaboratorTextP1: translate("collaboratorTextP1"),
  collaboratorTextP2: translate("collaboratorTextP2"),
  director: translate("director"),
  manager: translate("manager"),
  submanager: translate("submanager"),
  boss: translate("boss"),
  specialist: translate("specialist"),
  analist: translate("analist"),
  technical: translate("technical"),
  careerPlanText: translate("careerPlanText"),
  careerPlanPHRole: translate("careerPlanPHRole"),
  careerPlanPHArea: translate("careerPlanPHArea"),
  careerPlanBtnSearch: translate("careerPlanBtnSearch"),
  careerPlanBtnClean: translate("careerPlanBtnClean"),
  careerPlanPHNameColaborator: translate("careerPlanPHNameColaborator"),
  careerPlanNextLevel: translate("careerPlanNextLevel"),
  careerPlanSameAreas: translate("careerPlanSameAreas"),
  possibleAreas: translate("possibleAreas"),
};

export const loadingTranslate = {
  loadingP1: translate("loadingP1"),
  loadingP2: translate("loadingP2"),
};

export const multipleCollTranslate = {
  collBodyText: translate("collBodyText"),
  collDownloadSheet: translate("collDownloadSheet"),
  collUpSheet: translate("collUpSheet"),
  collArchive: translate("collArchive"),
};

export const badgeHeroesTranslate = {
  badgeHeroesTitle: translate("badgeHeroesTitle"),
  badgeHeroesTextCard: translate("badgeHeroesTextCard"),
};

export const mycoTranslate = {
  mycoTitle: translate("mycoTitle"),
  mycoTextCard: translate("mycoTextCard"),
};

export const KnowPaybalanceTranslate = {
  KnowPaybalanceTitle: translate("KnowPaybalanceTitle"),
  KnowPaybalanceTextCard: translate("KnowPaybalanceTextCard"),
};

export const onboardingTranslate = {
  collStatus: translate("collStatus"),
  assignStatus1: translate("assignStatus1"),
  assignStatus2: translate("assignStatus2"),
  collEmpty: translate("collEmpty"),
  responsable: translate("responsable"),
  registerResponsable: translate("registerResponsable"),
  registerCollaborator: translate("registerCollaborator"),
  professionalResponsableTitle: translate("professionalResponsableTitle"),

  onboardingAlertAnswer: translate("onboardingAlertAnswer"),

  statusOnboardingQuestion1: translate("statusOnboardingQuestion1"),
  statusOnboardingQuestion2: translate("statusOnboardingQuestion2"),
  statusOnboardingQuestion3: translate("statusOnboardingQuestion3"),
  statusOnboardingQuestion4: translate("statusOnboardingQuestion4"),
  statusOnboardingQuestion5: translate("statusOnboardingQuestion5"),
  statusOnboardingQuestion6: translate("statusOnboardingQuestion6"),
  statusOnboardingQuestion7: translate("statusOnboardingQuestion7"),

  statusOnboardingAnswerYes: translate("statusOnboardingAnswerYes"),
  statusOnboardingAnswerNo: translate("statusOnboardingAnswerNo"),
};

export const capacitationsTranslate = {
  capacitationTitle: translate("capacitationTitle"),
  capacitationsTitle: translate("capacitationsTitle"),
  capacitationChooseArea: translate("capacitationChooseArea"),
  newCourse: translate("newCourse"),
  capacitationCourse: translate("capacitationCourse"),
  capacitationArea: translate("capacitationArea"),
  capacitationEmpty: translate("capacitationEmpty"),
  capacitationCol: translate("capacitationCol"),
  capacitationAreaCol: translate("capacitationAreaCol"),
  capacitationProgress: translate("capacitationProgress"),
  className: translate("className"),
  courseDescription: translate("courseDescription"),
};

export const trainningTranslate = {
  trainningTitle: translate("trainningTitle"),
};

export const trainningListTranslate = {
  //English
  trainningCardTitleEnglish: translate("trainningCardTitleEnglish"),
  trainningCardTextEnglish: translate("trainningCardTextEnglish"),

  //Comercial & Selling
  trainningCardTitleComercialSelling: translate("trainningCardTitleComercialSelling"),
  trainningCardTextComercialSelling: translate("trainningCardTextComercialSelling"),

  //Gamefied Trainning
  trainningCardTitleGamefied: translate("trainningCardTitleGamefied"),
  trainningCardTextGamefied: translate("trainningCardTextGamefied"),
};

export const emptyContentBookTranslate = {
  empyContentText: translate("empyContentText"),
};

export const dashboardClimeTranslate = {
  dashboardClimeTitle: translate("dashboardClimeTitle"),
  leaveSearchTitle: translate("leaveSearchTitle"),
  leaveSearchNotFound: translate("leaveSearchNotFound"),
  emptyInformationClime: translate("emptyInformationClime"),
  textInformationBusinessCulture: translate("textInformationBusinessCulture"),
  textInformationBusinessCulture2: translate("textInformationBusinessCulture2"),
  climeQuestionsAlert: translate("climeQuestionsAlert"),
};

export const businessCultureQuestions = {
  //cultural
  businessCulturalQ1: translate("businessCulturalQ1"),
  businessCulturalQ2: translate("businessCulturalQ2"),
  businessCulturalQ3: translate("businessCulturalQ3"),
  businessCulturalQ4: translate("businessCulturalQ4"),
  businessCulturalQ5: translate("businessCulturalQ5"),
  businessCulturalQ6: translate("businessCulturalQ6"),

  //Career
  businessCareerQ1: translate("businessCareerQ1"),
  businessCareerQ2: translate("businessCareerQ2"),
  businessCareerQ3: translate("businessCareerQ3"),
  businessCareerQ4: translate("businessCareerQ4"),
  businessCareerQ5: translate("businessCareerQ5"),
  businessCareerQ6: translate("businessCareerQ6"),

  //leader
  businessLeaderQ1: translate("businessLeaderQ1"),
  businessLeaderQ2: translate("businessLeaderQ2"),
  businessLeaderQ3: translate("businessLeaderQ3"),
  businessLeaderQ4: translate("businessLeaderQ4"),
  businessLeaderQ5: translate("businessLeaderQ5"),
  businessLeaderQ6: translate("businessLeaderQ6"),

  //interests
  businessInterestsQ1: translate("businessInterestsQ1"),
  businessInterestsQ2: translate("businessInterestsQ2"),
  businessInterestsQ3: translate("businessInterestsQ3"),
  businessInterestsQ4: translate("businessInterestsQ4"),
  businessInterestsQ5: translate("businessInterestsQ5"),
  businessInterestsQ6: translate("businessInterestsQ6"),
};

export const promoterScoreTranslate = {
  netPromoteScoreTitle: translate("netPromoteScoreTitle"),
  detractorTitle: translate("detractorTitle"),
  detractorText: translate("detractorText"),
  neutralTitle: translate("neutralTitle"),
  neutralText: translate("neutralText"),
  promotorTitle: translate("promotorTitle"),
  promotorText: translate("promotorText"),
};

export const businessCultureTranslate = {
  businessCultureTitle: translate("businessCultureTitle"),
};

export const cultureBusinessTranslate = {
  businessCultureTitle: translate("businessCultureTitle"),
  asksTimelineText: translate("asksTimelineText"),
  cbTimelineStart: translate("cbTimelineStart"),
  cbTimeLineQuestions: translate("cbTimeLineQuestions"),
  cbTimeLineCareer: translate("cbTimeLineCareer"),
  cbTimeLineLeader: translate("cbTimeLineLeader"),
  cbTimeLineInterests: translate("cbTimeLineInterests"),
  cbTimeLineReportDelivery: translate("cbTimeLineReportDelivery"),
  cbTimeLineAswer: translate("cbTimeLineAswer"),
  cbTimeLineComercial: translate("cbTimeLineComercial"),
  cbTimeLineComercialDesc: translate("cbTimeLineComercialDesc"),
  cbTimeLineDisruptive: translate("cbTimeLineDisruptive"),
  cbTimeLineDisruptiveDec: translate("cbTimeLineDisruptiveDec"),
  cbTimeLineColaborate: translate("cbTimeLineColaborate"),
  cbTimeLineColaborateDesc: translate("cbTimeLineColaborateDesc"),
  cbTimeLineTraditional: translate("cbTimeLineTraditional"),
  cbTimeLineTraditionalDesc: translate("cbTimeLineTraditionalDesc"),
};

export const performanceEmployerTranslate = {
  saveButton: translate("saveButton"),
  employerPerformanceTitle: translate("employerPerformanceTitle"),
  employersShowCollumTitle: translate("employersShowCollumTitle"),
  employerCriterionCollumTitle: translate("employerCriterionCollumTitle"),
  employerWeigthCollumTitle: translate("employerWeigthCollumTitle"),
  employerExecutedCollumTitle: translate("employerExecutedCollumTitle"),
};

export const salariesAndBenefitsTranslate = {
  closeButton: translate("closeButton"),
  salaryConsultTitle: translate("salaryConsultTitle"),
  salaryConsultText: translate("salaryConsultText"),
  salaryConsultErrorEmptyFields: translate("salaryConsultErrorEmptyFields"),
  salaryConsultErrorIncompatibleSalary: translate("salaryConsultErrorIncompatibleSalary"),
  salaryConsultSuccessful: translate("salaryConsultSuccessful"),
  salaryConsultEducationLevel: translate("salaryConsultEducationLevel"),
  salaryConsultExperienceYears: translate("salaryConsultExperienceYears"),
  salaryConsultExperienceThreeLess: translate("salaryConsultExperienceThreeLess"),
  salaryConsultExperienceThreeOrSeven: translate("salaryConsultExperienceThreeOrSeven"),
  salaryConsultExperienceSevenOrMore: translate("salaryConsultExperienceSevenOrMore"),
  salaryConsultEnglishLevel: translate("salaryConsultEnglishLevel"),
  salaryConsultEnglishAloof: translate("salaryConsultEnglishAloof"),
  salaryConsultEnglishBasic: translate("salaryConsultEnglishBasic"),
  salaryConsultEnglishMid: translate("salaryConsultEnglishMid"),
  salaryConsultEnglishHigh: translate("salaryConsultEnglishHigh"),
  salaryConsultGrossMonthly: translate("salaryConsultGrossMonthly"),
  salaryConsultAnnualBonus: translate("salaryConsultAnnualBonus"),
  salaryConsultButtonSend: translate("salaryConsultButtonSend"),

  salaryRoleEmployee: translate("salaryRoleEmployee"),
  salaryRoleCoin: translate("salaryRoleCoin"),
  salaryRoleSalary: translate("salaryRoleSalary"),

  //SeniorityLevel
  salaryRoleSL1: translate("salaryRoleSL1"),
  salaryRoleSL2: translate("salaryRoleSL2"),
  salaryRoleSL3: translate("salaryRoleSL3"),
  salaryRoleSL4: translate("salaryRoleSL4"),

  //QualificationLevel
  salaryRoleQL1: translate("salaryRoleQL1"),
  salaryRoleQL2: translate("salaryRoleQL2"),
  salaryRoleQL3: translate("salaryRoleQL3"),
  salaryRoleQL4: translate("salaryRoleQL4"),

  salaryRoleAlert: translate("salaryRoleAlert"),

  dashboardTextClimeBenefits: translate("dashboardTextClimeBenefits"),
  alertEmptyDashboard: translate("alertEmptyDashboard"),

  //benefits
  benefitsText: translate("benefitsText"),
  benefitsSearchByCountry: translate("benefitsSearchByCountry"),

  alimentationTitle: translate("alimentationTitle"),
  alimentationText: translate("alimentationText"),
  transportTitle: translate("transportTitle"),
  transportText: translate("transportText"),
  lifeInsuranceTitle: translate("lifeInsuranceTitle"),
  lifeInsuranceText: translate("lifeInsuranceText"),
  certificationTitle: translate("certificationTitle"),
  certificationText: translate("certificationText"),
  vehicleTitle: translate("vehicleTitle"),
  vehicleText: translate("vehicleText"),
  tradingPowerTitle: translate("tradingPowerTitle"),
  tradingPowerText: translate("tradingPowerText"),
  computerTitle: translate("computerTitle"),
  computerText: translate("computerText"),
  gymTitle: translate("gymTitle"),
  gymText: translate("gymText"),
  anualBonusTitle: translate("anualBonusTitle"),
  anualBonusText: translate("anualBonusText"),
  bonusTitle: translate("bonusTitle"),
  bonusText: translate("bonusText"),
  equityTitle: translate("equityTitle"),
  equityText: translate("equityText"),
  stockOptionsTitle: translate("stockOptionsTitle"),
  stockOptionsText: translate("stockOptionsText"),

  //EmotionalSalary
  emotionalSalaryText: translate("emotionalSalaryText"),
  emotionalSalaryOptionSelect: translate("emotionalSalaryOptionSelect"),
};

export const jobsDescriptionTranslate = {
  jobsDescriptionTitle: translate("jobsDescriptionTitle"),
  jobsDescriptionShowMore: translate("jobsDescriptionShowMore"),
  jobsDescriptionReturn: translate("jobsDescriptionReturn"),
  jobsDescriptionTitleJob: translate("jobsDescriptionTitleJob"),
  jobsDescriptionActivies: translate("jobsDescriptionActivies"),
  jobsDescriptionFormation: translate("jobsDescriptionFormation"),
  jobsDescriptionPersonal: translate("jobsDescriptionPersonal"),
  jobsDescriptionRelacion: translate("jobsDescriptionRelacion"),
  jobsDescriptionLanguage: translate("jobsDescriptionLanguage"),
  jobsDescriptionStudy: translate("jobsDescriptionStudy"),
};

export const cardsTranslate = {
  apresentationDown: translate("apresentationDown"),
  activeService: translate("activeService"),
  customerEvaluation: translate("customerEvaluation"),
};

export const classesTranslate = {
  createNewClass: translate("createNewClass"),
  className: translate("className"),
  classLink: translate("classLink"),
  btnSave: translate("saveButton"),
};

export const complaintTranslate = {
  complaintSecurityText: translate("complaintSecurityText"),
  complaintSecuryTextBody: translate("complaintSecuryTextBody"),
  btnComplaint: translate("btnComplaint"),
  btnBack: translate("backButton"),
  complaintTypes: translate("complaintTypes"),
  complaintGenerate: translate("complaintGenerate"),
  complaintOptionA: translate("complaintOptionA"),
  complaintOptionB: translate("complaintOptionB"),
  complaintOptionC: translate("complaintOptionC"),
  complaintOptionD: translate("complaintOptionD"),
  complaintOptionE: translate("complaintOptionE"),
  complaintOptionF: translate("complaintOptionF"),
  complaintOptionG: translate("complaintOptionG"),
  complaintOptionH: translate("complaintOptionH"),
  complaintOptionI: translate("complaintOptionI"),
  complaintOptionJ: translate("complaintOptionJ"),
  complaintOptionK: translate("complaintOptionK"),
  complaintOptionL: translate("complaintOptionL"),
  complaintOptionM: translate("complaintOptionM"),
};

export const ombudsmanTranslate = {
  noOccurrences: translate("noOccurrences"),
  ombudmanTextOne: translate("ombudmanTextOne"),
  ombudmanTextTwo: translate("ombudmanTextTwo"),
  ombudsmanBtn: translate("ombudsmanBtn"),
};

export const referenceTranslate = {
  referencesTitle: translate("referencesTitle"),
  referencesText: translate("referencesText"),
  addReferenceBtn: translate("addReferenceBtn"),
  emptyReference: translate("emptyReference"),
  namePersona: translate("namePersona"),
  namePersonaPH: translate("namePersonaPH"),
  function: translate("function"),
  companyWorkTogetherPH: translate("companyWorkTogetherPH"),
  workRelation: translate("workRelation"),
  workRelation1: translate("workRelation1"),
  workRelation2: translate("workRelation2"),
  workRelation3: translate("workRelation3"),
  workRelation4: translate("workRelation4"),
  recomendationLetter: translate("recomendationLetter"),
  videoTextReference: translate("videoTextReference"),
  phoneReference: translate("phoneReference"),
  emailReference: translate("emailReference"),
};

export const candidateCVTranslate = {
  emptyValueCV: translate("emptyValueCV"),
  professionalExperienceCV: translate("professionalExperienceCV"),
  formationCV: translate("formationCV"),
  purposeCV: translate("purposeCV"),
  cultureCV: translate("cultureCV"),
  knowledgeCV: translate("knowledgeCV"),
  languagesCV: translate("languagesCV"),
  abilitiesCV: translate("abilitiesCV"),
  motivationsCV: translate("motivationsCV"),
  professionalHistoricCV: translate("professionalHistoricCV"),
  functionsCV: translate("functionsCV"),
  achiviementsCV: translate("achiviementsCV"),
  referencesCV: translate("referencesCV"),
  shareButtonCV: translate("shareButtonCV"),
};

export const personalInfoTranslate = {
  editProfileImg: translate("editProfileImg"),
  professionalInformation: translate("professionalInformation"),
  personalInformation: translate("personalInformation"),
  personalCompanyCol: translate("personalCompanyCol"),
  personalIndustryCol: translate("personalIndustryCol"),
  personalAreaCol: translate("personalAreaCol"),
  personalEntryDate: translate("personalEntryDate"),
  personalExitDate: translate("personalExitDate"),
  personalHastaFecha: translate("personalHastaFecha"),

  salaryDesc: translate("salaryDesc"),
  lastSalaryAdjust: translate("lastSalaryAdjust"),
  salaryExpectation: translate("salaryExpectation"),

  //Education
  personalEducation: translate("personalEducation"),
  personalEnglishLevel: translate("personalEnglishLevel"),
  personalELNulo: translate("personalELNulo"),
  personalELBasic: translate("personalELBasic"),
  personalELAverage: translate("personalELAverage"),
  personalELAdvanced: translate("personalELAdvanced"),
  personalELFluent: translate("personalELFluent"),
  personalUniversity: translate("personalUniversity"),
  personalType: translate("personalType"),
  personalClass: translate("personalClass"),

  //Salary
  personalSalary: translate("personalSalary"),
  personalFixBruteSalary: translate("personalFixBruteSalary"),
  personalCoin: translate("personalCoin"),
  personalVariableSalary: translate("personalVariableSalary"),

  //Formation
  personalAddInfo: translate("personalAddInfo"),
};

export const btnTranslate = {
  saveButton: translate("saveButton"),
  closeButton: translate("closeButton"),
  backButton: translate("backButton"),
  nextButton: translate("nextButton"),
  createButton: translate("createButton"),
  performTest: translate("performTest"),
  showResult: translate("showResult"),
  accessButton: translate("accessButton"),
};

export const myPurposesTranslate = {
  myPurposes: translate("myPurposes"),
  myPurposeText: translate("myPurposeText"),
  yourPurpose: translate("yourPurpose"),
};

export const progressBarTranslate = {
  progressText: translate("progressText"),
  progressMyProfile: translate("progressMyProfile"),
  progressProfileText: translate("progressProfileText"),
};

export const climeCultureTranslate = {
  climeAndCultureTitle: translate("climeAndCulture"),
  climeSurvey: translate("climeSurvey"),
  cultureSurveyText: translate("cultureSurveyText"),
  cultureSurvey: translate("cultureSurvey"),
  climeSurveyText: translate("climeSurveyText"),

  //Culture
  culturePreview: translate("culturePreview"),
  myCultureProfile: translate("myCultureProfile"),
  myCultureText: translate("myCultureText"),
  commercial: translate("commercial"),
  disruptive: translate("disruptive"),
  collaborative: translate("collaborative"),
  traditional: translate("traditional"),
  questionCulture: translate("questionCulture"),
  questionCarrer: translate("questionCarrer"),
  questionLeader: translate("questionLeader"),
  questionInterests: translate("questionInterests"),
};

export const abilitiesCollaboratorTranslate = {
  competeciaTitle: translate("competenciaTitle"),
  collaboratorWarning: translate("abilitiesCollaboratorTitleText"),
  collaboratorWarningTextP1: translate("abilitiesCollaboratorTextP1"),
  collaboratorWarningTextP2: translate("abilitiesCollaboratorTextP2"),
  collaboratorWarningTextP3: translate("abilitiesCollaboratorTextP3"),
  abilitiesCollaboratorTextEmail: translate("abilitiesCollaboratorTextEmail"),
  abilitiesCollaboratorDoubtsText: translate("abilitiesCollaboratorDoubtsText"),
};

export const motivacionCollaboratorTranslate = {
  motivacionTitle: translate("motivationTitle"),
  motivacionCollaboratorTitle: translate("motivacionCollaboratorTitle"),
  motivacionalCollaboratorTextP1: translate("motivacionalCollaboratorTextP1"),
  motivacionalCollaboratorTextP2: translate("motivacionalCollaboratorTextP2"),
  motivacionalCollaboratorTextP3: translate("motivacionalCollaboratorTextP3"),
  motivacionalCollaboratorTextEmail: translate("abilitiesCollaboratorTextEmail"),
  motivacionalCollaboratorDoubtsText: translate("abilitiesCollaboratorDoubtsText"),
};

export const performanceTranslate = {
  performanceTitle: translate("performanceTitle"),
  perfomanceFinalResult: translate("perfomanceFinalResult"),
};

export const emptyInformationTranslate = {
  incompleteProfile: translate("incompleteProfile"),
  incompleteTest: translate("incompleteTest"),
  emptyDesempeno: translate("emptyDesempeno"),
};

export const trainingsTranslate = {
  ebooks: translate("ebooks"),
  myTrainings: translate("myTrainings"),
  createNewTraining: translate("createNewTraining"),
  nulingaText: translate("nulingaText"),
  englishTestTitle: translate("englishText"),
};

export const employeeProfileEdit = {
  profileError: translate("profileError"),
};

export const internalJobsTranslate = {
  internalJobStep1: translate("internalJobStep1"),
  internalJobName: translate("internalJobName"),
  internalJobArea: translate("internalJobArea"),
  internalJobNivel: translate("internalJobNivel"),
  internalJobExperienceYears: translate("internalJobExperienceYears"),
  internalJobOptionArea: translate("internalJobOptionArea"),
  internalJobOptionNivel: translate("internalJobOptionNivel"),

  internalJobStep2: translate("internalJobStep2"),
  internalJobDescription: translate("internalJobDescription"),
  internalJobRequeriments: translate("internalJobRequeriments"),

  internalJobRequerimentsPlaceHolder: translate("internalJobRequerimentsPlaceHolder"),

  internalJobTitle: translate("internalJobTitle"),
  internalJobTableC1: translate("internalJobTableC1"),
  internalJobTableC2: translate("internalJobTableC2"),
  internalJobTableC3: translate("internalJobTableC3"),
  internalJobSearchPlaceHolder: translate("internalJobSearchPlaceHolder"),
  internalJobShowMore: translate("internalJobShowMore"),
  internalJobEmptyJob: translate("internalJobEmptyJob"),
  internalJobReturn: translate("internalJobReturn"),
};

export const paybalanceTranslate = {
  paybalanceTitle: translate("paybalanceTitle"),
  paybalanceDescription1: translate("paybalanceDescription1"),
  paybalanceDescription2: translate("paybalanceDescription2"),
  paybalanceDescription3: translate("paybalanceDescription3"),
  paybalanceDescription4: translate("paybalanceDescription4"),
  paybalanceDescription5: translate("paybalanceDescription5"),
  paybalanceTxt: translate("paybalanceTxt"),
  paybalanceBtn: translate("paybalanceBtn"),
};

export const outplacementTranslate = {
  outplacementAlertAnswer: translate("outplacementAlertAnswer"),
  outplacementQuestionOne: translate("outplacementQuestionOne"),
  outplacementQuestionTwo: translate("outplacementQuestionTwo"),
  outplacementQuestionThree: translate("outplacementQuestionThree"),
  outplacementQuestionFour: translate("outplacementQuestionFour"),
  outplacementQuestionFive: translate("outplacementQuestionFive"),
  outplacementQuestionSix: translate("outplacementQuestionSix"),
  outplacementQuestionSixPos: translate("outplacementQuestionSixPos"),
  outplacementQuestionSeven: translate("outplacementQuestionSeven"),
  outplacementAnswerYes: translate("outplacementAnswerYes"),
  outplacementAnswerNo: translate("outplacementAnswerNo"),
  outplacementAnswerOne: translate("outplacementAnswerOne"),
  outplacementAnswerTwo: translate("outplacementAnswerTwo"),
  outplacementAnswerThree: translate("outplacementAnswerThree"),
  outplacementAnswerFour: translate("outplacementAnswerFour"),
  outplacementOservation: translate("outplacementOservation"),
};

export const campaign = {
  campaignTitle: translate("campaignTitle"),
  campaignTxt: translate("campaignTxt"),
  campaignMenu: translate("campaignMenu"),
  campaignTableName: translate("campaignTableName"),
  campaignTableMail: translate("campaignTableMail"),
  campaignTableArea: translate("campaignTableArea"),
  campaignTableJob: translate("campaignTableJob"),
};

export const internalChannel = {
  internalChannelTitle: translate("internalChannelTitle"),
  internalChannelNewMessage: translate("internalChannelNewMessage"),
  internalChannelNoMessages1: translate("internalChannelNoMessages1"),
  internalChannelNoMessages2: translate("internalChannelNoMessages2"),
  internalChannelSendedMessages: translate("internalChannelSendedMessages"),
  internalChannelReceivedMessages: translate("internalChannelReceivedMessages"),
};
export const internalVacancies = {
  internalVacanciesTitle: translate("internalVacanciesTitle"),
  internalVacanciesCreate: translate("internalVacanciesCreate"),
  internalVacanciesActive: translate("internalVacanciesActive"),
};

export const mycoTest = {
  mycoAbilitiesQ1: translate("mycoAbilitiesQ1"),
  mycoAbilitiesQ2: translate("mycoAbilitiesQ2"),
  mycoAbilitiesQ3: translate("mycoAbilitiesQ3"),
  mycoAbilitiesQ4: translate("mycoAbilitiesQ4"),
  mycoAbilitiesQ5: translate("mycoAbilitiesQ5"),
  mycoAbilitiesQ6: translate("mycoAbilitiesQ6"),
  mycoAbilitiesQ7: translate("mycoAbilitiesQ7"),
  mycoAbilitiesQ8: translate("mycoAbilitiesQ8"),
  mycoAbilitiesQ9: translate("mycoAbilitiesQ9"),
  mycoAbilitiesQ10: translate("mycoAbilitiesQ10"),
  mycoAbilitiesQ11: translate("mycoAbilitiesQ11"),

  mycoMotivationsQ1: translate("mycoMotivationsQ1"),
  mycoMotivationsQ2: translate("mycoMotivationsQ2"),
  mycoMotivationsQ3: translate("mycoMotivationsQ3"),
  mycoMotivationsQ4: translate("mycoMotivationsQ4"),
  mycoMotivationsQ5: translate("mycoMotivationsQ5"),
  mycoMotivationsQ6: translate("mycoMotivationsQ6"),
  mycoMotivationsQ7: translate("mycoMotivationsQ7"),
  mycoMotivationsQ8: translate("mycoMotivationsQ8"),
  mycoMotivationsQ9: translate("mycoMotivationsQ9"),
  mycoMotivationsQ10: translate("mycoMotivationsQ10"),
  mycoMotivationsQ11: translate("mycoMotivationsQ11"),
  mycoMotivationsQ12: translate("mycoMotivationsQ12"),
  mycoMotivationsQ13: translate("mycoMotivationsQ13"),
  mycoMotivationsQ14: translate("mycoMotivationsQ14"),
  mycoMotivationsQ15: translate("mycoMotivationsQ15"),
  mycoMotivationsQ16: translate("mycoMotivationsQ16"),
  mycoMotivationsQ17: translate("mycoMotivationsQ17"),
};

export const myCompanyTranslate = {
  companyDetails: translate("companyDetails"),
  companyLogo: translate("companyLogo"),
  companyName: translate("companyName"),
  companyDescription: translate("companyDescription"),
  companyAnualBilling: translate("companyAnualBilling"),
  companyLocation: translate("companyLocation"),
  companySize: translate("companySize"),
  companySize1: translate("companySize1"),
  companySize2: translate("companySize2"),
  companySize3: translate("companySize3"),
  companyEmployeeAmount: translate("companyEmployeeAmount"),
  companyContact: translate("companyContact"),
  companyPhone: translate("companyPhone"),
  companyWebPage: translate("companyWebPage"),
  companyProducts: translate("companyProducts"),
  companyAddProduct: translate("companyAddProduct"),
  companyContent: translate("companyContent"),
  companyUpVideos: translate("companyUpVideos"),
};

export const motivationsAvaliation = {
  motivationHeaderText: translate("motivationHeaderText"),
  motivationOption1: translate("motivationOption1"),
  motivationOption1Text: translate("motivationOption1Text"),
  motivationInputError: translate("motivationInputError"),
  motivationShowColab: translate("motivationShowColab"),
  motivationOption2: translate("motivationOption2"),
  motivationOption2Text: translate("motivationOption2Text"),
  motivationShowMyCo: translate("motivationShowMyCo"),
};

export const abilitiesAvaliation = {
  abilitiesHeaderText: translate("abilitiesHeaderText"),
  abilitiesOption1Text: translate("abilitiesOption1Text"),
  abilitiesOption1: translate("abilitiesOption1"),
  abilitiesInputError: translate("abilitiesInputError"),
  abilitiesShowColab: translate("abilitiesShowColab"),
  abilitiesOption2: translate("abilitiesOption2"),
  abilitiesOption2Text: translate("abilitiesOption2Text"),
  abilitiesShowMyCo: translate("abilitiesShowMyCo"),
};

export const QuotationMotivationAbilities = {
  quoationMotivationsAbilitiesText: translate("quoationMotivationsAbilitiesText"),
  downloadModel: translate("downloadModel"),
  getQuotation: translate("getQuotation"),
};

export const firstLoginTranslate = {
  //WelcomePage
  welcomePageTitle: translate("welcomePageTitle"),
  welcomePageText: translate("welcomePageText"),
  welcomePageText2: translate("welcomePageText2"),
  welcomePageBtn: translate("welcomePageBtn"),
  welcomePageText4: translate("welcomePageText4"),

  //Infos
  infoFirstLoginTitle: translate("infoFirstLoginTitle"),
  infoFirstLoginText: translate("infoFirstLoginText"),
  infoFirstLoginName: translate("infoFirstLoginName"),
  infoFirstLoginEmail: translate("infoFirstLoginEmail"),
  infoFirstLoginPhone: translate("infoFirstLoginPhone"),
  infoFirstLoginCountry: translate("infoFirstLoginCountry"),
  infoFirstLoginAreas: translate("infoFirstLoginAreas"),
  firstLoginBtn: translate("firstLoginBtn"),

  //Step1
  step1FirstLogin: translate("step1FirstLogin"),
  step1FirstLoginText: translate("step1FirstLoginText"),
  step1Company: translate("step1Company"),
  step1Industry: translate("step1Industry"),
  step1Position: translate("step1Position"),
  step1HierarchicalLevel: translate("step1HierarchicalLevel"),
  step1Area: translate("step1Area"),
  step1Working: translate("step1Working"),
  step1StartDate: translate("step1StartDate"),
  step1EndDate: translate("step1EndDate"),

  //Step2
  step2Title: translate("step2Title"),
  step2Text: translate("step2Text"),
  step2FixedSalary: translate("step2FixedSalary"),
  step2VariableSalary: translate("step2VariableSalary"),

  //Step3
  step3FirstLoginTitle: translate("step3FirstLoginTitle"),
  step3FirstLoginText: translate("step3FirstLoginText"),
  step3Formation: translate("step3Formation"),
  step3University: translate("step3University"),
  step3Career: translate("step3Career"),
  step3Type: translate("step3Type"),
  step3Studing: translate("step3Studing"),
  step3StartDate: translate("step3StartDate"),
  step3EndDate: translate("step3EndDate"),
  step3English: translate("step3English"),
  step3Level: translate("step3Level"),
  step3Basic: translate("step3Basic"),
  step3Intermediate: translate("step3Intermediate"),
  step3Advanced: translate("step3Advanced"),
  step3Fluent: translate("step3Fluent"),
};

export const miniProfileTranslate = {
  miniProfileText1: translate("miniProfileText1"),
  miniProfileText2: translate("miniProfileText2"),
  miniProfileText3: translate("miniProfileText3"),
  miniProfileText4: translate("miniProfileText4"),
  miniProfileText5: translate("miniProfileText5"),
  miniProfileText6: translate("miniProfileText6"),
  miniProfileText7: translate("miniProfileText7"),
  miniProfileText8: translate("miniProfileText8"),
  miniProfileText9: translate("miniProfileText9"),
  miniProfileText10: translate("miniProfileText10"),
  miniProfileBtn: translate("miniProfileBtn"),
};
